import { render, staticRenderFns } from "./PolicyDetail.vue?vue&type=template&id=5806503a&scoped=true"
import script from "./PolicyDetail.vue?vue&type=script&lang=js"
export * from "./PolicyDetail.vue?vue&type=script&lang=js"
import style0 from "./PolicyDetail.vue?vue&type=style&index=0&id=5806503a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5806503a",
  null
  
)

export default component.exports